<template>
  <div class="ccui-app-container">
    <div class="ccui-advanced-search-wrapper ccui-clearfix bottom-mar">
      <div class="ccui-tab-wrapper">
        <el-button
          :type="isFocus === 1 ? 'table-top-active' : 'table-top'"
          size="mini"
          >全部 ({{ totalNum }})</el-button
        >
      </div>
      <el-button
        size="mini"
        type="primary"
        style="position: absolute; right: 20px; top: 20px"
        @click="handlAdd"
        >新增</el-button
      >
    </div>
    <!-- 表格 -->
    <div class="ccui-multifunctional-table-wrapper">
      <el-table
        ref="multipleTable"
        :data="tableData"
        :fit="true"
        :row-style="rowClass"
        :cell-style="cellStyle"
        border
        class="ccui-multifunctional-table"
        @select-all="handleCheckAllChange"
        @select="handleCheckChange"
        @selection-change="handleSelectionChange"
        @header-dragend="tableTitleWidth"
        @sort-change="sortChange"
        max-height="9999"
        v-if="draggFlag"
      >
        <template v-for="(table, index) in tableTheadOptions">
          <el-table-column
            v-if="table.checked"
            :fixed="table.fixed || false"
            :key="index"
            :type="table.type"
            :label="table.label"
            :align="table.align || 'left'"
            :header-align="table.headerAlign || 'left'"
            :width="table.width"
            :min-width="table.minWidth"
            :prop="table.prop"
            :formatter="formatterList[table.formatterName]"
            :show-overflow-tooltip="true"
            border="true"
          >
          </el-table-column>
        </template>

        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              ref="subcongradeyearsetting-item-detail"
              @click="handleGoDetail(scope.row)"
              >查看</el-button
            >
            <el-button
              size="mini"
              type="text"
              :disabled="
                scope.row.manageStatus !== '0' && scope.row.manageStatus !== '5'
              "
              ref="subcongradeyearsetting-edit-item"
              @click="handleGoEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="text"
              :disabled="
                scope.row.manageStatus !== '0' && scope.row.manageStatus !== '5'
              "
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
          <template v-slot:header>
            <div class="ccui-multifunctional-table-wrapper-operation">
              <span>操作</span>
              <el-popover
                placement="right"
                popper-class="ccui-multifunctional-table-wrapper_setting__popover"
                trigger="click"
              >
                <el-checkbox
                  v-for="(e, i) in fixedTableThead"
                  :key="i"
                  :checked="e.checked"
                  disabled
                  class="ccui-popover-disabled"
                  >{{ e.label }}</el-checkbox
                >
                <div class="ccui-popover-line"></div>
              </el-popover>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- <div
      class="table-footer"
      style="height: 35px; margin-top: 10px; padding: 0 10px"
    >
      <div class="ccui-table-footer">
        <div class="ccui-left">共 {{ inventoryTotal }} 条</div>
        <div id="ccui-paging">
          <el-pagination
            :total="inventoryTotal"
            :page-size="inventoryPageSize"
            :current-page="inventoryPageNoCode"
            prev-text="< 上一页"
            next-text="下一页 >"
            background
            layout=" total, prev, pager, next, jumper"
            popper-class="ccui-paging-page-size-popper"
            @current-change="inventoryHandleCurrentChange"
          />
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
require("core-js/modules/es.object.assign");
require("core-js/modules/es.object.keys");
require("regenerator-runtime/runtime");
require("core-js/modules/es.object.values");
require("core-js/modules/es.object.set-prototype-of");
require("core-js/modules/es.array.find");
require("core-js/modules/es.array-buffer.is-view");
require("core-js/modules/es.weak-map");
require("core-js/modules/es.promise");
import {
  getExternalExpertDetail,
  deleteExpert,
  checkIsTakeEffect
} from "@/app/sourceManage/api/expert";

import {
  setSessionItem,
  getSessionItem,
  removeSessionItem,
  ishasAgentId
} from "@/basa/utils";

export default {
  name: "perfectInformation",
  data() {
    return {
      isShowDetail: true,
      isShowEdit: true,
      multiDataToEnd: {},
      singleDataToEnd: {},
      // 表格相关
      tableData: [], // 表格数据
      draggFlag: true,
      tableName: this.tableList.subcongradeyearsettingList, // 表格命名
      tableThead: [], // 表格数据
      // 锁定表格
      fixedTableThead: [
        {
          label: "序号",
          prop: "id",
          width: "60",
          checked: true,
          fixed: true,
          type: "index",
          resizable: false
        }
      ],
      // 非锁定表格
      unfixedTableThead: [
        {
          label: "专家姓名",
          prop: "expertName",
          width: "200",
          checked: true
        },
        {
          label: "申请时间",
          prop: "applyTime",
          width: "200",
          checked: true,
          formatterName: "applyTimeHandler"
        },
        {
          label: "审批单位",
          prop: "manageUnitName",
          minWidth: "300",
          fixed: false,
          checked: true
        },
        {
          label: "审批状态",
          prop: "manageStatusStr",
          width: "150",
          checked: true
        }
      ],
      // 动态表格
      tableTheadOptions: [],
      // 弹框表格
      // popoverShow: false,
      selectRow: [],
      selectData: [],
      isFocus: 1,
      // 表格相关 end
      // 高级搜索数据 start
      formData: {
        startDate: "",
        applyTime: "",
        year: "",
        remark: "",
        manageApprovalStatus: ""
      }, // 高级搜索提交数据
      formDataSearch: "",
      localSearchData: {},
      isShowSearch: true,
      isShow: false,
      // 高级搜索数据 end
      isShowPagination: false, //无数据的不展示底部全选，批量删除
      // 全选以及页码
      totalNum: 0,
      total: 0,
      isIndeterminate: false,
      checkAll: false,
      value: "",
      pageNoCode: this.getLocalPageNo(),
      pageSizeCode: this.getLocalPageSize(),
      // isFist: false,
      // 全选以及页码 end
      // 表格数据删除相关
      delDemoId: "",
      content: "您确定要删除吗？",
      typeDel: "", //有关批量删除
      isSelection: false,
      // 表格数据删除相关 end
      // 排序入参所需字段
      sortord: "",
      sortprop: "",
      // 表格数据相关处理
      formatterList: {
        startDateHandler(row, col) {
          return row.startDate ? row.startDate.substr(0, 10) : "";
        },
        applyTimeHandler(row, col) {
          return row.applyTime ? row.applyTime.substr(0, 10) : "";
        },
        manageApprovalStatusHandler(row, col) {
          switch (row.manageApprovalStatus) {
            case 0:
              return "生效";
            case 1:
              return "失效";
          }
        },
        isCreated: false
      }
      // 表格数据相关处理 end
    };
  },
  mounted() {
    checkIsTakeEffect({}).then(res => {
      if (res.data.code === "0") {
        if (res.data.data.isTakeEffect !== "1") {
          this.$message({
            message: "请先进行信息完善！",
            type: "warning"
          });
          this.$router.push(
            `/expertManage/expertManages/perfectInformation/list`
          );
        } else {
          this.getList();
          this.initData();
        }
      }
    });
  },
  methods: {
    initData() {
      this.isShow = false;
      this.setTableWidth();
      this.renderTable();
      // this.isFist = false;
    },
    // 根据返回状态显示不同的文字颜色
    // eslint-disable-next-line no-unused-vars
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (this.selectRow.includes(rowIndex)) {
        return { "background-color": "transparent" };
      }
    },
    // 默认渲染表格
    renderTable() {
      const localTableData = localStorage.getItem(this.tableName)
        ? JSON.parse(localStorage.getItem(this.tableName))
        : [];
      let unfixedTableThead = this.unfixedTableThead.concat(
        this.fixedTableThead
      );
      let localTableDataStr = localTableData.map(
        ({ label, prop, formatter, align }) =>
          JSON.stringify({ label, prop, formatter, align })
      );
      let unfixedTableTheadStr = unfixedTableThead.map(
        ({ label, prop, width, formatter, align }) =>
          JSON.stringify({ label, prop, formatter, align })
      );

      if (localTableData.length === unfixedTableThead.length) {
        let flag = localTableDataStr.every(item =>
          unfixedTableTheadStr.includes(item)
        );
        if (flag) {
          // 完全相同
          this.tableTheadOptions = localTableData;
          this.tableThead = localTableData;
          this.unfixedTableThead = localTableData.filter(item => {
            return !this.fixedTableThead.find(
              cItem => item.prop === cItem.prop
            );
          });
        } else {
          // 长度相同但值不同
          this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
          const comment = JSON.stringify(this.tableThead);
          localStorage.setItem(this.tableName, comment);
          const localTableData = JSON.parse(
            localStorage.getItem(this.tableName)
          );
          this.tableTheadOptions = localTableData;
        }
      } else {
        // 长度不同
        this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
        const comment = JSON.stringify(this.tableThead);
        localStorage.setItem(this.tableName, comment);
        const localTableData = JSON.parse(localStorage.getItem(this.tableName));
        this.tableTheadOptions = localTableData;
      }
    },
    // 表格弹框拖拽触发
    handleTableChange(val) {
      this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
      const comment = JSON.stringify(this.tableThead);
      localStorage.setItem(this.tableName, comment);
      const localTableData = JSON.parse(localStorage.getItem(this.tableName));
      this.tableTheadOptions = localTableData;
    },
    // 是否显示对应列
    handleUpdate(item, index) {
      for (let i = 0; i < this.unfixedTableThead.length; i++) {
        if (i === index) {
          this.unfixedTableThead.checked = !this.unfixedTableThead.checked;
        }
      }
      this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
      const comment = JSON.stringify(this.tableThead);
      localStorage.setItem(this.tableName, comment);
      const localTableData = JSON.parse(localStorage.getItem(this.tableName));
      this.tableTheadOptions = localTableData;
    },
    // 渲染本地存储表格宽度
    setTableWidth() {
      const localTableData = JSON.parse(localStorage.getItem(this.tableName));
      if (localTableData) {
        for (let i = 0; i < this.tableTheadOptions.length; i++) {
          if (this.tableTheadOptions[i].label === localTableData[i].label) {
            this.tableTheadOptions[i].width = localTableData[i].width;
          }
        }
      }
    },
    // 表格宽度更改存入
    tableTitleWidth(newWidth, oldWidth, column, event) {
      for (let i = 0; i < this.unfixedTableThead.length; i++) {
        if (this.unfixedTableThead[i].label === column.label) {
          this.unfixedTableThead[i].width = newWidth;
        }
      }
      this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
      const comment = JSON.stringify(this.tableThead);
      localStorage.setItem(this.tableName, comment);
      this.tableTheadOptions = JSON.parse(localStorage.getItem(this.tableName));
      this.draggFlag = false;
      this.$nextTick(() => {
        this.draggFlag = true;
      });
    },
    handleSelectionChange(data) {
      this.selectData = data;
    },
    rowClass({ row, rowIndex }) {
      if (this.selectRow.includes(rowIndex)) {
        return { "background-color": "rgba(255,232,195,1) " };
      }
    },

    handlAdd() {
      this.$router.push(
        "/expertManage/expertManages/manageNnitAdd/edit?type=1"
      );
    },
    // 跳转详情页
    handleGoDetail(row) {
      this.$router.push(
        "/expertManage/expertManages/manageNnitAdd/detail?manageUnitId=" +
          row.manageUnitId +
          "&type=1"
      );
    },
    // 跳转编辑页
    handleGoEdit(row) {
      this.$router.push(
        "/expertManage/expertManages/manageNnitAdd/edit?type=2&manageUnitId=" +
          row.manageUnitId
      );
    },

    // 删除列表数据
    handleDelete(row) {
      let params = [row.expertId];
      this.$confirm("您确定要删除吗？", "删除确认", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "ccui-message-box-custom"
      })
        .then(() => {
          deleteExpert({
            expertIds: params,
            expertManageId: row.expertManageId
          }).then(res => {
            if (res) {
              this.$message({
                type: "success",
                duration: 3000,
                message: "删除成功"
              });
              this.getList();
            }
          });
        })
        .catch(() => {
          console.log("取消删除");
        });
    },
    // 高级搜索所需函数 start
    // 高级搜索展开按钮
    search(searchData) {
      this.pageNoCode = 1;
      this.formDataSearch = searchData;
      this.localSearchData = JSON.parse(JSON.stringify(searchData));
      setSessionItem("pageNo", this.tableName, {
        pageNo: this.pageNoCode,
        searchForm: this.localSearchData
      });
      this.getList(this.formDataSearch);
    },
    // 高级搜索 end
    // 列表数据请求
    getList(reqObj) {
      console.log(this.pageNoCode);
      let obj = {};
      obj = typeof reqObj == "object" ? reqObj : obj;
      obj.pageNo = this.pageNoCode;
      obj.pageSize = this.pageSizeCode;
      obj.isCurrent = 1;
      obj.isTakeEffect = 0;
      obj.isShowPageLoading = true;
      getExternalExpertDetail(obj)
        .then(res => {
          this.isShowPagination = false;
          // if (
          //   res.data.data.sscExpertManageUnitBO &&
          //   res.data.data.sscExpertManageUnitBO.length > 0
          // ) {
          this.tableData = res.data.data.sscExpertManageUnitBO || [];
          this.totalNum = res.data.data.sscExpertManageUnitBO.length;
          this.total = res.data.data.sscExpertManageUnitBO.length;
          // } else {
          //   this.tableData = [res.data.data.expertDetailBO];
          //   this.totalNum = 1;
          //   this.total = 1;
          // }

          this.pageNoCode = res.data.data.pageNo; // 当前页
        })
        .catch(e => {
          // console.log(e);
        });
    },
    // 全选
    handleCheckAllChange(val) {
      this.isIndeterminate = false;
      const arr = [];
      for (let i = 0; i < val.length; i++) {
        arr.push(val[i].id);
      }
      this.idArrSelected = arr;
      if (val.length) {
        this.isSelection = true;
      } else {
        this.isSelection = false;
      }
      if (typeof val === "boolean") {
        if (val) {
          this.toggleSelection(this.tableData);
        } else {
          this.toggleSelection([]);
        }
      } else {
        this.checkAll = val.length !== 0;
      }
    },
    // 底部全选
    handleCheckAllChangeBottom() {
      this.$refs.multipleTable.toggleAllSelection();
    },
    // 单个数据选中
    handleCheckChange(val) {
      const arr = [];
      for (let i = 0; i < val.length; i++) {
        arr.push(val[i].id);
      }
      this.idArrSelected = arr;
      if (val.length) {
        this.isSelection = true;
      } else {
        this.isSelection = false;
      }
      if (val.length > 0 && val.length < this.tableData.length) {
        this.isIndeterminate = true;
      } else if (val.length === this.tableData.length) {
        this.checkAll = true;
        this.isIndeterminate = false;
      } else {
        this.checkAll = false;
        this.isIndeterminate = false;
      }
    },
    toggleSelection(rows) {
      this.$refs.multipleTable.clearSelection();
      const arr = [];
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
          arr.push(row.id);
        });
        this.idArrSelected = arr;
      }
    },
    // 排序
    sortChange(params) {
      this.sortord = params.order;
      this.sortprop = params.prop;
      this.getList();
    },
    // 默认显示多少条
    getLocalPageSize() {
      return (
        getSessionItem("pageSize", this.tableList.subcongradeyearsettingList) ||
        20
      );
    },
    // 读取当前页缓存
    getLocalPageNo() {
      let localData = getSessionItem(
        "pageNo",
        this.tableList.subcongradeyearsettingList
      );
      return (localData && localData.pageNo) || 1;
    }
  },
  beforeRouteLeave(to, from, next) {
    removeSessionItem("pageNo");
    for (var key in this.$vnode.parent.componentInstance.cache) {
      delete this.$vnode.parent.componentInstance.cache[
        ishasAgentId(to.path, key)
      ];
    }
    next();
  },
  activated() {
    if (Object.keys(this.localSearchData).length > 0) {
      setSessionItem("pageNo", this.tableName, {
        pageNo: this.pageNoCode,
        searchForm: this.localSearchData
      });
    }
    let localData = getSessionItem(
      "pageNo",
      this.tableList.subcongradeyearsettingList
    );
    let data = localData && localData.searchForm;
    this.getList({ ...this.formDataSearch, ...data });
  }
};
</script>
<style lang="scss" scoped>
.bottom-mar {
  margin-bottom: 20px;
}
</style>
